import { render, staticRenderFns } from "./yesMessage.vue?vue&type=template&id=1835e1ae"
import script from "./yesMessage.vue?vue&type=script&lang=js"
export * from "./yesMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports